import React, { useState } from 'react';
import { create } from 'jss';
import rtl from 'jss-rtl';
import { StylesProvider, jssPreset } from '@material-ui/core/styles';

import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';
import { avenir, avenirIt, avenirBold, avenirThin } from 'avenirNextLTPro';
import i18n from 'i18n';
import MainComponent from 'views/components/mainComponent';

// Configure JSS
const jss = create({ plugins: [...jssPreset().plugins, rtl()] });


export default function RTL(props) {
    //const theme = useTheme();
    const [direction, setDirection] = useState("ltr");
    const [accentColor, setAccentColor] = useState("#d11f2e");

    const theme = createMuiTheme({
        direction: direction,
        palette: {
            primary: {
                // light: will be calculated from palette.primary.main,
                main: accentColor,
                // dark: will be calculated from palette.primary.main,
                contrastText: '#fff',
            },
            action: {
                disabledBackground: accentColor + "A0",
                disabled: '#fff'
            },
            // Used by `getContrastText()` to maximize the contrast between
            // the background and the text.
            contrastThreshold: 3,
            // Used by the functions below to shift a color's luminance by approximately
            // two indexes within its tonal palette.
            // E.g., shift from Red 500 to Red 300 or Red 700.
            tonalOffset: 0.3,
        },
        typography: {
            fontFamily: 'Avenir',
        },
    });
    //.slick-dots li.slick-active button:before
    theme.overrides = {
        MuiCssBaseline: {
            '@global': {
                '@font-face': [avenir, avenirIt, avenirBold, avenirThin],
            },

        },
        MuiButton: {
            root: {
                borderRadius: 0,
                "&:hover": {
                    backgroundColor: "none",
                }
            },
        },
        MuiDialog: {
            root: {
                borderRadius: 0,
            },
            paper: {
                borderRadius: 0,
            }
        },
        MuiToggleButtonGroup: {
            root: {
                borderRadius: 0
            }
        },
        MuiToggleButton: {
            root: {
                borderRadius: 0,
                color: "white",
                border: "1px solid " + theme.palette.primary.light,
                backgroundColor: theme.palette.primary.light,
                padding: "5px 10px 5px 10px",
                "&$selected": {
                    color: "white",
                    backgroundColor: theme.palette.primary.main,
                    "&:hover": {
                        backgroundColor: theme.palette.primary.dark
                    }
                },
                "&:hover": {
                    backgroundColor: theme.palette.primary.dark
                }
            }
        },
    };

    function changeAccentColor(color) {
        setAccentColor(color);
    }


    i18n.on('languageChanged', function (lng) {
        setDirection(i18n.dir(lng));
    })

    document.body.setAttribute("dir", direction);

    return (
        <StylesProvider jss={jss}>
            <ThemeProvider theme={theme}>
                <MainComponent accentColor={accentColor} changeColor={changeAccentColor} />
            </ThemeProvider>
        </StylesProvider>
    );
}